import { routes } from "@/router/all_routes";
import type { BillingDocumentSource } from "@/core/billing/billing-documents/types";
import { BILLING_SOURCE_LABELS } from "@/core/billing/billing-source-labels";

export type ServiceImplementationStatus = "live" | "partial" | "planned";

export interface HospitalServiceDefinition {
  id: string;
  label: string;
  route: string;
  billingSource: BillingDocumentSource | null;
  status: ServiceImplementationStatus;
  description: string;
}

/** Catalogue des services — source de vérité pour le hub et la roadmap. */
export const HOSPITAL_SERVICE_REGISTRY: HospitalServiceDefinition[] = [
  {
    id: "admissions",
    label: "Admissions",
    route: routes.admissions,
    billingSource: "consultation",
    status: "live",
    description: "Accueil, orientation et comptabilité consultation.",
  },
  {
    id: "emergency",
    label: "Urgences",
    route: routes.emergency,
    billingSource: "emergency",
    status: "live",
    description: "Triage, orientation et prise en charge urgences.",
  },
  {
    id: "ambulance",
    label: "Transports ambulance",
    route: routes.ambulanceTransports,
    billingSource: "ambulance",
    status: "live",
    description: "Arrivées SMUR / ambulance et suivi transport.",
  },
  {
    id: "hospitalization",
    label: "Hospitalisation",
    route: routes.hospitalization,
    billingSource: "hospitalization",
    status: "live",
    description: "Séjours, lits et attribution.",
  },
  {
    id: "patientConsumables",
    label: "Consommables patient",
    route: routes.patientConsumables,
    billingSource: "patient_consumables",
    status: "live",
    description: "Saisie et facturation consommables WH-CONS par patient.",
  },
  {
    id: "nursing",
    label: "Soins infirmiers",
    route: routes.nursingCare,
    billingSource: "nursing",
    status: "live",
    description: "Constantes, tournées et validation.",
  },
  {
    id: "consultations",
    label: "Consultations",
    route: routes.consultations,
    billingSource: "consultation",
    status: "live",
    description: "Consultations médicales et clôture d'actes.",
  },
  {
    id: "surgery",
    label: "Chirurgie / bloc",
    route: routes.surgery,
    billingSource: "surgery",
    status: "live",
    description: "Orientations bloc, dossiers actes et facturation détaillée.",
  },
  {
    id: "laboratory",
    label: "Laboratoire",
    route: routes.laboratory,
    billingSource: "laboratory",
    status: "live",
    description: "Demandes d'analyses et résultats.",
  },
  {
    id: "imaging",
    label: "Imagerie",
    route: routes.imaging,
    billingSource: "imaging",
    status: "live",
    description: "Examens, planning et comptes-rendus.",
  },
  {
    id: "pharmacy",
    label: "Pharmacie",
    route: routes.pharmacyOrders,
    billingSource: "prescription",
    status: "live",
    description: "Ordonnances, dispensation et vente comptoir.",
  },
];

export function serviceBillingLabel(source: BillingDocumentSource | null): string {
  if (!source) return "—";
  return BILLING_SOURCE_LABELS[source];
}
